/**
 * Featured products. Talks to the /featured group, which is the admin.php
 * "Featured Products" tab moved into Connect: it curates the list the app shows
 * at the top of MOST POPULAR. Storage and shape are unchanged, so the app reads
 * exactly what it always did.
 *
 * Non-namespaced like every other module here. The list goes over the wire as a
 * JSON string because the API speaks form-urlencoded and decodes it itself.
 */
const notifyError = (commit, message) =>
  commit("NOTIFICATION_MESSAGE", { status: -1, title: "Featured", message });

const form = (obj) => {
  const p = new URLSearchParams();
  Object.keys(obj).forEach((k) => {
    const v = obj[k];
    p.append(k, Array.isArray(v) || (v && typeof v === "object") ? JSON.stringify(v) : v);
  });
  return p;
};

const state = () => ({
  featured: [],
  stores: [],
  catalog: [],
  loaded: false,
  // A failed load has to be visible on the page, not just a toast that vanishes.
  error: "",
});

const mutations = {
  RESET_FEATURED(s) { Object.assign(s, state()); },
  SET_FEATURED(s, { featured, stores }) {
    s.featured = featured || [];
    s.stores = stores || [];
    s.loaded = true;
    s.error = "";
  },
  SET_FEATURED_CATALOG(s, v) { s.catalog = v || []; },
  SET_FEATURED_ERROR(s, m) { s.error = m; s.loaded = true; },
};

const actions = {
  async getFeatured({ commit }) {
    commit("LOADING", { isActiveStatus: true });
    try {
      const { data } = await window.$http.axios.get("featured/get");
      if (data.status) commit("SET_FEATURED", { featured: data.featured, stores: data.stores });
      else {
        notifyError(commit, data.message);
        commit("SET_FEATURED_ERROR", data.message || "The server refused the request.");
      }
    } catch (e) {
      notifyError(commit, "Could not load featured products.");
      commit("SET_FEATURED_ERROR", "Could not reach the featured-products service. It may not be installed on this server yet.");
    } finally {
      commit("LOADING", { isActiveStatus: false });
    }
  },

  async getFeaturedCatalog({ commit, state: s }) {
    if (s.catalog.length) return;
    try {
      const { data } = await window.$http.axios.get("featured/catalog");
      if (data.status) commit("SET_FEATURED_CATALOG", data.products);
    } catch (e) {
      // The picker just stays empty; the page still works for reordering/removing.
    }
  },

  async saveFeatured({ commit }, featured) {
    commit("LOADING", { isActiveStatus: true });
    try {
      const payload = (featured || []).map((e) => ({
        phash: e.phash,
        priority: Number(e.priority) || 100,
        store_id: e.store_id == null ? null : Number(e.store_id),
      }));
      const { data } = await window.$http.axios.post("featured/save", form({ featured: payload }));
      if (data.status) {
        commit("NOTIFICATION_MESSAGE", {
          status: 1,
          title: "Featured",
          message: "Saved " + (data.count || 0) + " featured product" + ((data.count || 0) === 1 ? "" : "s") + ".",
        });
        return true;
      }
      notifyError(commit, data.message || "Save failed.");
      return false;
    } catch (e) {
      notifyError(commit, "Save failed. The featured-products service may not be installed yet.");
      return false;
    } finally {
      commit("LOADING", { isActiveStatus: false });
    }
  },
};

export default { state, mutations, actions };
